import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// components
import { Paper as PaperOrigin } from 'components/UI'
import { Chip as ChipOrigin, Grid2 as Grid } from '@mui/material'
// icons
import FormIconOrigin from 'src/icons/forms.svg'
import ScheduleReviewIconOrigin from 'src/icons/schedule-review.svg'
// utils
import { darken, size } from 'polished'

const Paper = styled(PaperOrigin)<{ width?: string }>`
  padding: 16px;
  width: ${({ width }) => width};
`

const Header = styled('div')`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  position: relative;
`

const Container = styled((props) => <Grid {...props} />)`
  && {
    margin-bottom: 12px;
  }
`

const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

const FormIcon = styled(FormIconOrigin)`
  && {
    cursor: pointer;
    margin-left: 5px;
    ${size('25px')};
  }
`

const Chip = styled(({ isRepeatingReview, ...props }) => <ChipOrigin {...props} />)`
  && {
    font-size: 14px;
    justify-content: space-between;
    width: ${({ isRepeatingReview }) => (isRepeatingReview ? '208px' : '212px')};

    & > span {
      display: unset;
      max-width: 87%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

const ScheduleReviewIcon = styled(ScheduleReviewIconOrigin)`
  && {
    margin: 0 5px 0 12px;
    ${size('25px')};
  }
`

const IconWrapper = styled('div')`
  align-items: center;
  color: ${colors.blue500};
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
  margin-bottom: 16px;
`

const ButtonWrapper = styled((props) => <Grid {...props} />)`
  && {
    margin-top: 20px;

    & > div {
      margin-right: 10px;
    }
  }
`

const ReviewerContainer = styled.div<{ $hasReviewer: boolean }>`
  width: ${({ $hasReviewer }) => ($hasReviewer ? 'unset' : '100%')};
  padding: 4px 4px 4px 0;
`

export {
  AddButton,
  ButtonWrapper,
  Chip,
  Container,
  FormIcon,
  Header,
  IconWrapper,
  Paper,
  ReviewerContainer,
  ScheduleReviewIcon
}
